var classes = {"tab":"YhILP","tabHorizontal":"exTIC","tabVertical":"_2ShWU","tabSelected":"fkAYT","horizontalTabBar":"A3jW0","verticalTabBar":"CsShe","verticalTabBarUnselected":"CAUrL","verticalTabBarSelected":"BXqTp"};

export { classes as default };
